app.service('productDetailVariants', function (productCardConfig) {
	let $productVariants, $variantLists;
	let config;

	function init() {
		config = productCardConfig.getData();
		setElements();
		if (!$productVariants.length) return;
		if(config.showProductVariantPriceDifferences === true && !config.preview) {
			setPriceDifferenceForVariants(config.plu);
		}
		setEvents();
	}

	function setElements() {
		$productVariants = $('#product-variants');
		$variantLists = $('.variant-list', $productVariants);
	}

	function setEvents() {
		$('.js-show-more-items').on('click', toggleMoreItems);
		$('body').on('click', '.js-variant-item', function (e) {
			e.preventDefault();
			logEvent($(this));
			window.location.href = this.href;
		});
	}

	function toggleMoreItems() {
		let indexOfList = $(this).data('listIndex');
		$(this).toggleClass('open');
		$(`.js-variant-list-${indexOfList}`).toggleClass('show-more-items');
	}

	function logEvent($element) {
		let data = ($element.data('event') || '').split("|");
		if(data.length === 6) {
			UA.pageInteraction( 'Wariantowanie - ' + data[5], $.trim($element.attr('title')) );

			app.logEvent({
				id: 'wariantowanie',
				f03: data[0],
				f04: data[1],
				f05: data[2],
				f06: data[3],
				f07: data[4]
			});
		}
	}

	function setPriceDifferenceForVariants(currentCode) {
		getPriceDiferrenceData(currentCode).then(priceDifferences => {
			applyPricesToVariantItems(priceDifferences);
		})
	}

	function applyPricesToVariantItems(priceDifferences) {
		$('.variant-item', $variantLists).not('.variant-unavailable').each((index, item) => {
			let priceDataForItem = priceDifferences.find(elem => elem.variantIdentifier === item.dataset.identifier)
			if(priceDataForItem && priceDataForItem.priceDifference) {
				$(item).append(`<span class="price-difference">${priceDataForItem.priceDifference}</span>`);
			}
		})
	}

	function getPriceDiferrenceData(code) {
		return $.ajax({
			url: '/product-variant/price-difference.ltr',
			method: 'GET',
			data: { code }
		});
	}

	return {
		init
	};
});